import { render } from "./RecipeDropdownList.vue?vue&type=template&id=bb42d362&scoped=true&ts=true"
import script from "./RecipeDropdownList.vue?vue&type=script&lang=ts"
export * from "./RecipeDropdownList.vue?vue&type=script&lang=ts"

import "./RecipeDropdownList.vue?vue&type=style&index=0&id=bb42d362&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb42d362"]])

export default __exports__